/*
 * @Description: 积分管理
 * @Author: guqiang
 * @Date: 2021-09-18 11:40:38
 * @LastEditors: guqiang
 * @LastEditTime: 2021-10-27 18:24:49
 */
import request from './request';
/**
 * @description: 获取积分用户列表
 * @param {*} params https://yapi.iklicen.com/project/139/interface/api/435482
 * @return {*}
 */
export function getCustomers(params) {
    return request('/customer/search', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 客户剩余积分
 * @param {*} params http://yapi.iklicen.com/project/139/interface/api/435483
 * @return {*}
 */
export function getCustomerScore(id) {
    return request(`/points/customer/${id}/remain-points`, {
        method: 'GET',
    });
}

/**
 * @description: 积分赠送
 * @param {*} params https://yapi.iklicen.com/project/139/interface/api/435481
 * @return {*}
 */
export function putRewardCoin(params) {
    return request('points/gift', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 积分扣除
 * @param {*} params https://yapi.iklicen.com/project/139/interface/api/435481
 * @return {*}
 */
export function putDeductCoin(params) {
    return request('/points/deduct', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 积分记录列表
 * @param {*} params https://yapi.iklicen.com/project/139/interface/api/435479
 * @return {*}
 */
export function postCoinRecords(params) {
    return request('/points/record/list', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 积分概况列表
 * @param {*} params https://yapi.iklicen.com/project/139/interface/api/435484
 * @return {*}
 */
export function postCoinSums(params) {
    return request('/points/overview/list', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 操作人列表
 * @param {*} params http://yapi.iklicen.com/project/139/interface/api/65149
 * @return {*}
 */
export function postOperators(params = {}) {
    return request('/user/all', {
        method: 'POST',
        params,
    });
}
